import { createFileRoute } from '@tanstack/react-router'
import { lazy, Suspense } from 'react'
const Page = lazy(() => import('@/features/ban-hang/san-pham/page.client'))
export const Route = createFileRoute('/_authed/agent/ban-hang/san-pham')({
  component: () => <Suspense fallback={null}><Page /></Suspense>,
})